module.exports = [{
  plugin: require('/vercel/7fbf03d3/node_modules/@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/vercel/7fbf03d3/deck.mdx",
    "dirname": "/vercel/7fbf03d3"
  }
}];